function ThreeDotLoader() {
  return <div className="dot-flashing" />;
}

export default ThreeDotLoader;
